import React from 'react';
import {Redirect} from 'react-router-dom';

import {createRoutes} from '../@crema/utility/Utils';
import {dashBoardConfigs} from './dashboard';
import {errorPagesConfigs} from './errorPages';
import {authRouteConfig} from './auth';
import {initialUrl} from '../shared/constants/AppConst';
import {tokenRouteConfig} from './token';
import {goldReserveRouteConfig} from './goldReserve';
import {priceRouteConfig} from './price';
import {adminRouteConfig} from './admin';
import {RouteConfig} from 'react-router-config';
import {myAccountRouteConfig} from './myAccount';
import {feesRouteConfig} from './fees';
import {specialWalletsConfig} from './specialWallets';
import {feeManagementRouteConfig} from './feeManagement';

const routeConfigs = [
  ...authRouteConfig,
  ...dashBoardConfigs,
  ...errorPagesConfigs,
  ...tokenRouteConfig,
  ...goldReserveRouteConfig,
  ...priceRouteConfig,
  ...adminRouteConfig,
  ...myAccountRouteConfig,
  ...feesRouteConfig,
  ...specialWalletsConfig,
  ...feeManagementRouteConfig
];

const routes: RouteConfig[] = [
  ...createRoutes(routeConfigs),
  {
    path: '/',
    exact: true,
    component: function Home(): React.ReactElement {
      return <Redirect to={initialUrl} />;
    },
  },
  {
    component: function ErrorPage(): React.ReactElement {
      return <Redirect to='/error-pages/error-404' />;
    },
  },
];

export default routes;
